// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"872d0ba5","153":"5008effa","473":"97a2ce68","770":"e3f17bd2"}[chunkId] + ".chunk.js";
};